/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TemplateItem } from '../../models/template-item';

export interface GetAvailableTemplates$Params {
}

export function getAvailableTemplates(http: HttpClient, rootUrl: string, params?: GetAvailableTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TemplateItem>>> {
  const rb = new RequestBuilder(rootUrl, getAvailableTemplates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TemplateItem>>;
    })
  );
}

getAvailableTemplates.PATH = '/sample/instruction/template/list';
